var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticStyle: { height: "100% !important" },
      attrs: { fluid: "", "grid-list-md": "", id: "ada" }
    },
    [
      _c("v-dialog", {
        attrs: { transition: "dialog-bottom-transition" },
        model: {
          value: _vm.showInfo,
          callback: function($$v) {
            _vm.showInfo = $$v
          },
          expression: "showInfo"
        }
      }),
      _c(
        "v-tabs",
        { attrs: { left: "", color: "transparent" } },
        [_c("v-tab", [_vm._v("Mantenedor")])],
        1
      ),
      _c("v-divider", { staticStyle: { "margin-bottom": "1%" } }),
      _c("Tag")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }